
import { AloDbMissionPlanTemplate, IAloDbMissionPlanTemplateConstParam } from '@/models/alodb/AloDbMissionPlanTemplate';
import { FilterBase } from '@/models/filter/FilterBase';

export interface IMissionPlanTemplateState {
    status:string
    missionPlanTemplates: Array<AloDbMissionPlanTemplate>
    modifiedAdmMissionPlanTemplate: AloDbMissionPlanTemplate
    originalAdmMissionPlanTemplate: AloDbMissionPlanTemplate
    missionPlanTemplateLoading: boolean
    adminFilter: FilterBase
}
  
const state:IMissionPlanTemplateState = { 
    status: '',
    missionPlanTemplates: [],
    modifiedAdmMissionPlanTemplate: new AloDbMissionPlanTemplate(),
    originalAdmMissionPlanTemplate: new AloDbMissionPlanTemplate(),
    missionPlanTemplateLoading:false,
    adminFilter: new FilterBase()
}
  
export default state